import { PriceFileFormatEffects } from './price-file-format.effects';
import { PriceFileRequestTemplateEffects } from './price-file-request-template.effects';
import { PriceFileEffects } from './price-file.effect';

export const effects: any[] = [PriceFileEffects, PriceFileFormatEffects, PriceFileRequestTemplateEffects];

export * from './price-file.effect';
